<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret produktpakke
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="internalnamegroup">
											<label for="name">
												Internt navn
											</label>
											<input v-model="internalname" type="text" ref="internalname" value>
										</div>

										<div class="input-group" ref="namegroup">
											<label for="name">
												Navn
											</label>
											<input v-model="name" type="text" ref="name" value>
										</div>

										<div class="input-group" ref="typegroup">
											<label for="name">
												Type
											</label>
											<select v-model="type" ref="type">
												<option value="1">Billedepakke</option>
												<option value="7">Billedepakke sekundær</option>
												<option value="6">Nyt motiv</option>
												<option value="4">Ekstra ved køb af billedepakke</option>
												<option value="5">Uden billedepakke køb</option>
												<option value="2">Tilkøbsprodukt</option>
												<option value="3">Fragt og service</option>
												<option value="8">Fragt og service (Krævet)</option>
											</select><span></span>
										</div>

										<div class="input-group" ref="pricegroup">
											<label for="price">
												Pris
											</label>
											<input v-model="price" type="number" step="0.01" ref="price" value>
										</div>

									</div>

									<div class="form-group">

										<div class="input-group" ref="descriptiongroup">
											<label for="description">
												Beskrivelse
											</label>
											<textarea v-model="description" name="description" ref="description" class="large"></textarea>
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="form-groups">
									<div class="form-group form-group-fullwidth" ref="productsgroup">
										<div class="input-group-hori">
											<div class="input-group nopad">
												<label for="height">
													Produkter
												</label>
											</div>
										</div>
										<div class="input-group-hori equal draggable-group" v-if="!noProducts">
											<draggable group="productpackage"
													   v-bind="packageProductsDragOptions"
													   class="draggable-container draggable-container-target"
													   :list="packageProducts"
													   @change="setDraggableIndexes">
												<div class="draggable-item draggable-item-quantity" v-for="(element) in packageProducts" :key="element.productid">
													<div class="text">
														<span>{{ element.quantity }} stk.</span> {{ element.name }}
													</div>
													<div class="buttons">
														<button data-ic="O" @click.self="setQuantity(element, 1)"></button>
														<button data-ic="X" @click.self="setQuantity(element, -1)"></button>
													</div>
												</div>
											</draggable>
											<draggable group="productpackage"
													   v-bind="allPackageProductsDragOptions"
													   class="draggable-container draggable-container-source"
													   :list="allProductPackageProducts">
												<div class="draggable-item" v-for="(element) in allProductPackageProducts" :key="element.productid">
													{{ element.name }}
													<div class="small faded" style="padding-top: 2px;">{{ getProductType(element.type) }}</div>
												</div>
											</draggable>
										</div>
										<div class="input-group-hori" ref="productsgroup" v-if="noProducts">
											Der er endnu ikke oprettet nogen produkter, der kan tilknyttes pakken.
										</div>
									</div>
								</div>
								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="deleteData" class="delete left" v-if="dialogMode == 'edit'">
										Slet
									</button>
									<button type="button" @click.prevent="close" class="text space">
										Tilbage
									</button>
									<button type="button" @click.prevent="saveData">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { appFeedbackStateEnum } from "@/app/enums/common"
	import { productTypeEnum } from "@/app/enums/common"
	import draggable from "vuedraggable"

	export default {
		name: "ProductPackageEdit",
		components: {
			draggable
		},
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret produktpakke",
				productpackageID: "0",
				allProductPackageProducts: [],
				packageProducts: [],
				noProducts: true,

				internalname: "",
				name: "",
				price: "",
				description: "",
				type: "1",
				productpackage: {
					internalname: "",
					name: "",
					price: "",
					description: "",
					type: "1"
				}
			}
		},
		mounted()
		{
			this.setModalIsVisible()
			this.loadProducts()

			if (this.$route.name == "ProductPackageEdit")
			{
				this.dialogMode = "edit"
				this.dialogTitle = "Rediger produktpakke"
				this.productpackageID = this.$route.params.productpackageid
				this.loadData()
			}
			else
			{
				this.dialogMode = "create"
				this.dialogTitle = "Opret produktpakke"
				this.$refs.internalname.focus()
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		computed: {
			allPackageProductsDragOptions()
			{
				return {
					sort: false,
					easing: "cubic-bezier(1, 0, 0, 1)",
					animation: 200,
					ghostClass: "ghost",
					dragClass: "chosen"
				};
			},
			packageProductsDragOptions()
			{
				return {
					easing: "cubic-bezier(1, 0, 0, 1)",
					animation: 200,
					ghostClass: "ghost",
					dragClass: "chosen"
				};
			}
		},
		methods:
		{
			setQuantity(element, quantityChange)
			{
				element.quantity = element.quantity + quantityChange
				element.quantity = element.quantity < 1 ? 1 : element.quantity
			},
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.internalname != this.productpackage.internalname)
				changes = changes || (this.name != this.productpackage.name)
				changes = changes || (this.price != this.productpackage.price)
				changes = changes || (this.description != this.productpackage.description)

				if (!changes && this.dialogMode == "edit")
				{
					for (var product of this.productpackage.products)
					{
						let existingProduct = this.packageProducts.find(pp => pp.productid == product.productid);

						if (existingProduct)
						{
							if (product.quantity != existingProduct.quantity || product.index != existingProduct.index)
							{
								changes = true
								break
							}
						}
						else
						{
							changes = true
							break
						}
					}

					for (var product of this.packageProducts)
					{
						let newProduct = this.productpackage.products.find(pp => pp.productid == product.productid);

						if (!newProduct)
						{
							changes = true
							break
						}
					}
				}

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false;
			},
			getProductType(type)
			{
				switch (type)
				{
					case productTypeEnum.PORTRAIT:
						return "Portræt"
					case productTypeEnum.GROUPPHOTO:
						return "Gruppefoto"
					case productTypeEnum.VIDEO:
						return "Video"
					case productTypeEnum.USBSTICK:
						return "USB-stick"
					case productTypeEnum.BOOK:
						return "Bog"
					default:
						return "Andet"
				}
			},
			close()
			{
				if (this.checkForChanges())
				{
					return;
				}

				this.$router.push({ name: "Products" })
			},
			setDraggableIndexes()
			{
				let index = 0
				for (var product of this.packageProducts)
				{
					index++
					product.index = index
				}
			},
			async loadProducts()
			{
				var productsResult = await this.$store.dispatch(types.ACTION_GET_PRODUCTS);

				if (productsResult.status == 200)
				{
					if (productsResult.data && productsResult.data.length > 0)
					{
						this.noProducts = false

						for (var product of productsResult.data)
						{
							var sortProduct =
							{
								id: 0,
								productid: product.id,
								name: product.name,
								quantity: 1,
								type: product.type
							}

							this.allProductPackageProducts.push(sortProduct)
						}
					}
				}
				else
				{
					this.setAppAsIdle()
					logError("ProductPackageEdit.loadProducts()", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.");
					this.$router.push({ name: "Products" })
				}
			},
			async loadData()
			{
				if (this.productpackageID)
				{
					this.setAppAsBusyModal();

					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_PRODUCTPACKAGE, this.productpackageID);

						if (result.status == 200)
						{
							this.productpackage = result.data;
							this.internalname = result.data.internalname
							this.name = result.data.name
							this.price = result.data.price
							this.description = result.data.description
							this.type = result.data.type
							this.packageProducts = []

							if (result.data.products && result.data.products.length > 0)
							{
								for (var product of result.data.products)
								{
									var addProduct =
									{
										id: product.id,
										index: product.index,
										productid: product.productid,
										productpackageid: product.productpackageid,
										quantity: product.quantity
									}

									this.packageProducts.push(addProduct)
								}

								var allProductPackageProductsTraversed = this.allProductPackageProducts

								for (var product of this.allProductPackageProducts)
								{
									var packageProduct = this.packageProducts.find(pp => pp.productid == product.productid)

									if (packageProduct)
									{
										packageProduct.name = product.name
										allProductPackageProductsTraversed = allProductPackageProductsTraversed.filter(product => product.productid != packageProduct.productid)
									}
								}

								this.allProductPackageProducts = allProductPackageProductsTraversed
							}

							this.setAppAsIdle()
						}
						else
						{
							this.setAppAsIdle()
							logError("ProductPackageEdit.loadData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
							this.$router.push({ name: "Products" })
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("ProductPackageEdit.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "Products" })
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen. 6");
					this.$router.push({ name: "Products" })
				}
			},
			async saveData()
			{
				try
				{
					var valid = true
					var validationFocus = false

					if (this.internalname.length == 0)
					{
						this.$refs.internalnamegroup.setAttribute("data-validation", "Indtast venligst et internt navn")
						this.$refs.internalname.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.internalnamegroup.removeAttribute("data-validation")
					}

					if (this.name.length == 0)
					{
						this.$refs.namegroup.setAttribute("data-validation", "Indtast venligst et navn")
						if (!validationFocus) this.$refs.name.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.namegroup.removeAttribute("data-validation")
					}

					if (this.price.length == 0)
					{
						this.$refs.pricegroup.setAttribute("data-validation", "Indtast venligst en pris")
						if (!validationFocus) this.$refs.price.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.pricegroup.removeAttribute("data-validation")
					}

					if ((!this.allProductPackageProducts || !this.packageProducts) || this.packageProducts.length == 0)
					{
						this.$refs.productsgroup.setAttribute("data-validation", "Vælg venligst mindst ét produkt til pakken")
						valid = false
					}
					else
					{
						this.$refs.productsgroup.removeAttribute("data-validation")
					}

					if (!valid)
					{
						return;
					}

					this.setAppAsBusyModal()
					this.setDraggableIndexes()

					var data =
					{
						id: this.productpackageID,
						internalname: this.internalname,
						name: this.name,
						price: this.price,
						description: this.description,
						type: this.type,
						products: this.packageProducts
					}

					if (this.dialogMode == "edit")
					{
						var result = await this.$store.dispatch(types.ACTION_UPDATE_PRODUCTPACKAGE, data);

						if (result.status == 200)
						{
							this.productpackage = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
							this.$router.push({ name: "Products" })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle();

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede en produktpakke med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message);
								alert("Der opstod en fejl. Opdater siden og prøv igen.");
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("ProductPackage.saveData()", result.status)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
					else
					{
						var result = await this.$store.dispatch(types.ACTION_ADD_PRODUCTPACKAGE, data);

						if (result.status == 201)
						{
							this.productpackage = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.ADDED)
							this.$router.push({ name: "Products" })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle();

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede et produktpakke med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message);
								alert("Der opstod en fejl. Opdater siden og prøv igen.");
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("ProductPackage.saveData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
				}
				catch (ex)
				{
					this.showErrorAlert(ex)
					this.setAppAsIdle()
				}
			},
			async deleteData()
			{
				if (confirm("Er du sikker? Sletningen kan ikke fortrydes."))
				{
					try
					{
						await this.$store.dispatch(types.ACTION_DELETE_PRODUCTPACKAGE, this.productpackageID)
							.then(response =>
							{
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.$router.push({ name: "Products" })
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("ProductPackage.deleteData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
							});
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("ProductPackage.deleteData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "Products" })
					}
				}
			},
		}
	};
</script>